import { render, staticRenderFns } from "./WhitelistTypes.vue?vue&type=template&id=810d79b8"
import script from "./WhitelistTypes.vue?vue&type=script&lang=js"
export * from "./WhitelistTypes.vue?vue&type=script&lang=js"
import style0 from "./WhitelistTypes.vue?vue&type=style&index=0&id=810d79b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports